<div class="border-bottom navy-bg main-nav">
	<div class="container">
		<nav class="row navbar navbar-static-top mb-0" role="navigation">
			<div class="col-lg-4 header-logo">
				<a class="logo-link" [routerLink]="portfolioLandingNavigation()">
					<img title="InfoDocs Icon White Transparent" class="logo" src="assets/img/infodocs-icon.png" />
				</a>
				<div id="table-portfolio_filter" class="dataTables_filter form-group">
					<label class="d-flex search-input-table align-items-center">
						<div class="search-input">
							<input
								autofocus
								type="search"
								class="form-control"
								style="
									border-right-style: none;
									border-bottom-right-radius: 0;
									border-top-right-radius: 0;
									border-color: white;
								"
								placeholder="Search or add company"
								id="company-search-input"
								[formControl]="searchQueryControl"
								(keydown.enter)="submitSearch($event)"
							/>
						</div>
						<app-search-button
							[btnClass]="['btn-outline-primary']"
							[isBusy]="isSearchingCompany()"
							submitLabel=""
							busyLabel=""
							(clicked)="submitSearch()"
						/>
					</label>
					@if (isSearchResultsOpen()) {
						<div
							#searchResultsDropdown
							class="private-header-search-dropdown"
							(click)="$event.stopPropagation()"
						>
							@if (errorMessage()) {
								<alert type="danger" size="small">
									{{ errorMessage() }}
								</alert>
							} @else {
								<div class="private-header-search__results">
									@for (company of currentPortfolioCompanies(); track company.id) {
										<div class="private-header-search__row">
											<span class="private-header-search__name">
												{{ company.company_name }} ({{ company.registration_number }})
											</span>
											<a
												class="private-header-search__action"
												(click)="closeSearchResults()"
												[routerLink]="['/company', 'profile', company.id]"
											>
												Go To Dashboard
											</a>
										</div>
									}
									@for (
										company of companiesSearched();
										track company.CompanyInformation.CompanyRegistrationNumber
									) {
										<div class="private-header-search__row">
											<span class="private-header-search__name">
												{{ company.CompanyInformation.CompanyName }}
												({{ company.CompanyInformation.CompanyRegistrationNumber }})
												@if (company.CompanyExists === 'Archived') {
													<app-archived-badge />
												}
											</span>
											@if (company.CompanyExists === 'False' || company.CompanyExists === 'Archived') {
												<a
													class="private-header-search__action navbar-search-preview"
													(click)="previewCompany(company)"
													title="Preview {{ company.CompanyInformation.CompanyName }}"
												>
													Preview
												</a>
											}
											@if (company.CompanyExists === 'Already added') {
												<a
													class="private-header-search__action"
													(click)="closeSearchResults()"
													[routerLink]="[
														'/company',
														'profile',
														company.CompanyInformation.CompanyId
													]"
												>
													Go To Dashboard
												</a>
											}
											@if (company.CompanyExists === 'Request access') {
												<a
													class="private-header-search__action navbar-search-request-access"
													(click)="previewCompany(company)"
													title="Request access to {{ company.CompanyInformation.CompanyName }}"
												>
													Request Access
												</a>
											}
										</div>
									}
									@if (!currentPortfolioCompanies().length && !companiesSearched().length) {
										<div class="private-header-search__row">
											<span class="private-header-search__name">No results found.</span>
											<a
												class="private-header-search__action"
												(click)="openManualAddCompanyModal()"
											>
												+ Manual Add
											</a>
										</div>
									}
								</div>
							}
						</div>
					}
				</div>
			</div>
			<div class="col-lg-8">
				<ul>
					@if (accountService.isFree()) {
						<li>
							<button class="btn-upgrade" (click)="openUpgradeSubscriptionModal()">Upgrade</button>
						</li>
					}
					<app-portfolio-nav-dropdown [companiesRoute]="portfolioLandingNavigation()" />
					<li>
						<a class="nav-menu-link" routerLink="/user/profile">
							<app-icon class="private-header-profile-icon" [icon]="profileNavIcon()" />
							<span class="nav-label">Profile</span>
						</a>
					</li>
					@if (!accountService.isGuest()) {
						<li>
							<a class="nav-menu-link" routerLink="/account">
								<app-icon [icon]="faUsersIcon" />
								<span class="nav-label">Account</span>
							</a>
						</li>
					}
					@if (!accountService.isFree()) {
						<li>
							<a
								class="nav-menu-link"
								[href]="auth.isSupportUser() ? environment.novaUrl : environment.helpCentreUrl"
								target="_blank"
								rel="noopener noreferrer"
							>
								<app-icon [icon]="faHeartIcon" />
								<span class="nav-label">Support</span>
							</a>
						</li>
					}
					<li>
						<a class="nav-menu-link log-out-link" (click)="auth.logout()" routerLink="/account/login">
							<app-icon [icon]="faSignOutAltIcon" />
							<span class="nav-label">Log Out</span>
						</a>
					</li>
				</ul>
			</div>
		</nav>
	</div>
</div>

<!--	ALERT CARD-->
@if (alerts().length && alerts()[0].id) {
	<div class="container mt-4">
		<div class="row">
			<div class="col-md-12">
				<div role="alert" [ngClass]="setAlertType(alerts()[0].alert_type)">
					<strong>{{ alerts()[0].title }}: </strong>
					<span class="alert-message" [innerHTML]="markdownToHtml(alerts()[0].message)"></span>
					<button class="close" (click)="markAlertAsRead(alerts()[0].id)">&times;</button>
				</div>
			</div>
		</div>
	</div>
}
